/**
 * Horizontal bar list of the most common decline reasons. The BE has
 * already grouped by case-insensitive trim and rolled the long tail into
 * an "Other" bucket — we just render. Hover shows the absolute count.
 */
import ChartCard from "../ChartCard/ChartCard";
import { formatCount } from "../../../../../constants/analytics.constants";
import { DeclineReasonsStyles } from "./declineReasons.styles";

const DeclineReasonsChart = ({ data = [] }) => {
  const max = Math.max(1, ...data.map(d => d.count));
  return (
    <ChartCard
      title="Top decline reasons"
      subtitle="Grouped by case-insensitive trim · top 8 + Other"
    >
      {data.length === 0 ? (
        <div style={{ flex: 1, display: "grid", placeItems: "center", color: "#8E8E8E", fontSize: 12 }}>
          No declined services in this range
        </div>
      ) : (
        <DeclineReasonsStyles>
          {data.map((row, i) => {
            const pct = (row.count / max) * 100;
            return (
              <div key={`${row.reason}-${i}`} className="hbar-row">
                <div className="hbar-label" title={row.reason}>
                  {row.reason}
                </div>
                <div className="hbar-track">
                  <div className="hbar-fill" style={{ width: `${pct}%` }} />
                </div>
                <div className="hbar-value">{formatCount(row.count)}</div>
              </div>
            );
          })}
        </DeclineReasonsStyles>
      )}
    </ChartCard>
  );
};

export default DeclineReasonsChart;
